"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![ChevronLeftIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDYuNzEgMTIuNDEiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICNmZmY7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0aXRsZT5DaGV2cm9uTGVmdDwvdGl0bGU+CiAgPGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+CiAgICA8ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPgogICAgICA8cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik02LjIxLDEyLjQxYS41NC41NCwwLDAsMS0uMzYtLjE0TC4xNSw2LjU2YS41LjUsMCwwLDEsMC0uNzFMNS44NS4xNWEuNS41LDAsMCwxLC43MSwwLC41LjUsMCwwLDEsMCwuN0wxLjIxLDYuMjFsNS4zNSw1LjM1YS41MS41MSwwLDAsMSwwLC43MUEuNTQuNTQsMCwwLDEsNi4yMSwxMi40MVoiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=)
 */
exports.ChevronLeftIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 6.71 12.41", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("path", { d: "M6.21 12.41a.54.54 0 0 1-.36-.14L.15 6.56a.5.5 0 0 1 0-.71l5.7-5.7a.5.5 0 0 1 .71 0 .5.5 0 0 1 0 .7L1.21 6.21l5.35 5.35a.51.51 0 0 1 0 .71.54.54 0 0 1-.35.14z" })));
};
//# sourceMappingURL=Icon.ChevronLeft.js.map